export default __webpack_public_path__ + "static/aon-21aac17a56f51cbf6e9b4a3c816db117.png";